export enum HEALTH_STATUS {
  CRITICAL = 'critical',
  ALARM = 'alarm',
  MONITOR = 'monitor',
  HEALTHY = 'healthy',
  NOT_AVAILABLE = 'na',
  //  Add more statuses here
}

export enum HealthStatusLabel {
  StatusChange = 'The status has been updated',
  NotFullyMonitored = 'Not Fully Monitored',
  // Add more labels here
}
